 
/**
 * Composant modal simple et efficace
 */
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.button = this.querySelector('.popup-modal__button');
    this.modalId = this.dataset.modal;
    
    if (!this.button || !this.modalId) return;
    
    this.modal = document.getElementById(this.modalId);
    if (!this.modal) return;
    
    this.closeButton = this.modal.querySelector('.popup-modal__toggle');
    this.setupEvents();
  }

  setupEvents() {
    // Ouverture
    this.button.addEventListener('click', () => this.open());
    
    // Fermeture
    this.closeButton?.addEventListener('click', () => this.close());
    
    // Fermeture avec Échap
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    });
    
    // Fermeture par clic sur l'arrière-plan
    document.body.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });
  }

  open() {
    this.processImage();
    this.modal.classList.add('active');
    document.body.classList.add('overflow-hidden');
    this.modal.focus();
  }

  close() {
    this.modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.button.focus();
  }

  processImage() {
    const contentInfo = this.modal.querySelector('.popup-modal__content-info');
    const encodedImage = contentInfo?.dataset.image;
    
    if (encodedImage) {
      const decoded = this.decodeImage(encodedImage);
      if (decoded) {
        contentInfo.innerHTML = decoded;
        contentInfo.removeAttribute('data-image');
      }
    }
  }

  decodeImage(encoded) {
    try {
      return decodeURIComponent(escape(atob(encoded)));
    } catch {
      return null;
    }
  }

  isOpen() {
    return this.modal?.classList.contains('active');
  }
}

customElements.define('modal-opener', ModalOpener);